export default "__VITE_ASSET__Df0TaKEr__"